<!--

    * 404.svelte
    404 Error fallback page to help guide those lost souls
    
-->



<div class="top-background" style="background-image:url(images/backgrounds/404.jpg);">
    <h1 class="page-title">404, this page was not found</h1>
    <!-- Credit to the photographer (not required but still giving it) -->
    <div class="credit">
        Photo by <a href="https://unsplash.com/@danedeaner?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Dane Deaner</a>
    </div>
</div>

<section id="contact">

    <div class="content">
        <p>All is not lost! You can search for what you're looking for.</p><br>
        <form class="form-search" method="get" action="http://www.ubc.ca/search/refine/" role="search">
            <input type="text" name="q" placeholder="Search this website" class="input-xlarge search-query search-box">
                <input type="hidden" name="label" value="Search Life Cycle Management Laboratory" />
            <input type="hidden" name="site" value="*.lcml.engineering.ok.ubc.ca" />
            <button type="submit" class="btn action-button">Search</button>
        </form> 
    </div>

</section>




<style lang="sass">

@import "./consts.sass"
@include page-header()
@include search-box()
@include action-button()

.content
    padding: 2em
    box-sizing: border-box

    @media only screen and (min-width: 1200px) 
        padding-right: 10vw
        padding-left: 10vw

    .about-diagram
        width: 100%
        
</style>